import { memo } from 'react';
import InputLabel from '@mui/material/InputLabel';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DayValidationProps } from '@mui/x-date-pickers/internals';
import dayjs from 'dayjs';

import { DatePickerHookProps } from '.';

type DatePickerHookFormProps = {
  name: string;
  helperText?: string;
  shouldDisableDate?: DayValidationProps<any>['shouldDisableDate'];
} & DatePickerHookProps;

export const DatePickerHookForm = memo<DatePickerHookFormProps>(
  function DatePickerHookForm({
    name,
    label,
    minDate = null,
    maxDate = null,
    disableFuture = true,
    helperText = undefined,
    shouldDisableDate = undefined,
    inputProps,
    textFieldProps,
    ...props
  }: DatePickerHookFormProps) {
    const { control } = useFormContext();

    const minDateDayjs = dayjs.isDayjs(minDate) ? dayjs(minDate) : null;
    const maxDateDayjs = dayjs.isDayjs(maxDate) ? dayjs(maxDate) : null;

    return (
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field, fieldState }) => {
          return (
            <div>
              {label && <InputLabel htmlFor={name}>{label}</InputLabel>}
              <DatePicker
                {...props}
                format="DD/MM/YYYY"
                disableFuture={disableFuture}
                minDate={minDateDayjs}
                maxDate={maxDateDayjs}
                value={field.value ? dayjs(field.value) : null}
                onChange={(date: any) => {
                  field.onChange(date?.format('YYYY/MM/DD') || null);
                }}
                shouldDisableDate={shouldDisableDate}
                disabled={props?.disabled}
                slotProps={{
                  textField: {
                    size: 'small',
                    error: !!fieldState.error,
                    helperText: fieldState?.error?.message || helperText,
                    InputProps: inputProps,
                    inputProps: { 'data-testid': name },
                    sx: {
                      ...props?.sx,
                    },
                    ...textFieldProps,
                  },
                }}
              />
            </div>
          );
        }}
      />
    );
  }
);
